import { PluginBody, PluginName } from "./types";

export const plugins: { [key in PluginName]: PluginBody<key> } = {
  SALESFORCE_CHAT: {
    init: pConfig => {
      const config = pConfig.config;
      let isAgentAvailable: boolean = false;
      let isChatEnded: boolean = false;
      const {
        embedded_svc
      }: {
        embedded_svc: {
          settings: any;
          init: any;
          inviteAPI: any;
          addEventHandler: any;
        };
      } = window as any;
      Object.assign(embedded_svc.settings, config.settings);
      if ("baseCoreURL" in config.init) {
        embedded_svc.init(
          config.init.baseCoreURL,
          config.init.communityEndpointURL,
          config.init.gslbBaseURL,
          config.init.orgId,
          config.init.eswConfigDevName,
          config.init.initSettings
        );
      }

      embedded_svc.addEventHandler("onAgentMessage", (data: Object) => {
        if (!isAgentAvailable) {
          document.body.dispatchEvent(
            new CustomEvent("chat-agent-joined", { detail: data })
          );
          isAgentAvailable = true;
        }
      });

      embedded_svc.addEventHandler("onChatEndedByAgent", (data: Object) => {
        document.body.dispatchEvent(
          new CustomEvent("chat-conference-ended", {
            detail: { reason: "Chat Ended By Agent" }
          })
        );
        isChatEnded = true;
      });

      embedded_svc.addEventHandler("onChatEndedByChasitor", (data: Object) => {
        document.body.dispatchEvent(
          new CustomEvent("chat-conference-ended", {
            detail: { reason: "Chat Ended By Chasitor" }
          })
        );
        isChatEnded = true;
      });

      embedded_svc.addEventHandler("afterDestroy", (data: Object) => {
        if (!isChatEnded) {
          document.body.dispatchEvent(
            new CustomEvent("chat-conference-ended", {
              detail: { reason: "Chat Window Closed" }
            })
          );
        }
        isAgentAvailable = false;
        isChatEnded = false;
      });
    }
  }
};
